import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  svg {
    height: 1.6875rem;
  }
`;

export const ColunmHead = styled.th<{ align: 'center' | 'left' | 'right' }>`
  text-align: align;
  padding-left: 0px;
  padding-bottom: 3px;
  border: none;
  font-size: 0.8571428571428571em;
  font-style: inherit;
  color: #6b778c;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

export const Colunm = styled.td<{
  align: 'center' | 'left' | 'right';
  width?: string;
}>`
  border: 1px solid #ccc;
  padding: 0.35rem;
  text-align: align;
  width: width;
`;
